/**
 * Yeasts database.
 */

export const YEASTS = [
  // Torr- & Ale-jäst
  {
    name: 'SafAle US-05',
    lab: 'Fermentis',
    type: 'ale',
    att_min: 78,
    att_max: 82,
    temp_min: 15,
    temp_max: 22,
    desc: 'Hembryggarens mest använda ale-jäst. Ren, neutral profil för APA, IPA, Stout.',
  },
  {
    name: 'SafAle S-04',
    lab: 'Fermentis',
    type: 'ale',
    att_min: 71,
    att_max: 75,
    temp_min: 18,
    temp_max: 22,
    desc: 'Brittisk alejäst. Snabb flockning, fyllig kropp och mild fruktighet.',
  },
  {
    name: 'Lallemand Verdant IPA',
    lab: 'Lallemand',
    type: 'ale',
    att_min: 75,
    att_max: 82,
    temp_min: 19,
    temp_max: 23,
    desc: 'Tropisk frukt och mjuk len kropp. Förstahandsval för NEIPA & Hazy IPA.',
  },
  {
    name: 'Wyeast 1318 London Ale III',
    lab: 'Wyeast',
    type: 'ale',
    att_min: 71,
    att_max: 75,
    temp_min: 18,
    temp_max: 23,
    desc: 'Brödig och fruktig flytande jäststorsäljare för NEIPA.',
  },
  {
    name: 'Nottingham Ale',
    lab: 'Lallemand',
    type: 'ale',
    att_min: 73,
    att_max: 82,
    temp_min: 14,
    temp_max: 21,
    desc: 'Hög förgäsning, neutral och extremt robust. Klarar breda temperaturer.',
  },
  {
    name: 'Lallemand BRY-97 West Coast',
    lab: 'Lallemand',
    type: 'ale',
    att_min: 75,
    att_max: 80,
    temp_min: 15,
    temp_max: 22,
    desc: 'Amerikansk West Coast-jäst. Hög flockning och mycket ren krispig smak.',
  },

  // Kveik (Jäs varmt i rumstemperatur utan kylning!)
  {
    name: 'Lallemand Voss Kveik',
    lab: 'Lallemand',
    type: 'ale',
    att_min: 75,
    att_max: 82,
    temp_min: 25,
    temp_max: 40,
    desc: 'Norsk kveik. Extremt snabb jäsning vid 35–40°C med fräsch apelsinarom utan finkeloljor!',
  },
  {
    name: 'Omega Lutra Kveik',
    lab: 'Omega Yeast',
    type: 'ale',
    att_min: 75,
    att_max: 82,
    temp_min: 20,
    temp_max: 35,
    desc: 'Extremt ren neutral kveik. Blixtsnabb jäsning för "fejk-lager" eller ren ale vid rumstemp.',
  },
  {
    name: 'Omega Hornindal Kveik',
    lab: 'Omega Yeast',
    type: 'ale',
    att_min: 75,
    att_max: 82,
    temp_min: 22,
    temp_max: 37,
    desc: 'Tropisk mango/ananas-kveik för Hazy IPAs och fruktdrivna ales.',
  },

  // Lager- & Hybridjäst
  {
    name: 'SafLager W-34/70',
    lab: 'Fermentis',
    type: 'lager',
    att_min: 80,
    att_max: 84,
    temp_min: 9,
    temp_max: 15,
    desc: 'Världens mest använda lagerjäst. Ren, krispig och stabil Weihenstephan-stam.',
  },
  {
    name: 'Lallemand Novalager',
    lab: 'Lallemand',
    type: 'lager',
    att_min: 78,
    att_max: 84,
    temp_min: 12,
    temp_max: 20,
    desc: 'Modern hybridlagerjäst. Krispig lagerprofil som kan jäsa varmare (15–18°C) utan diacetyl!',
  },
  {
    name: 'SafLager S-23',
    lab: 'Fermentis',
    type: 'lager',
    att_min: 70,
    att_max: 75,
    temp_min: 9,
    temp_max: 15,
    desc: 'Sydtysk lagerjäst med lätt fruktiga undertoner.',
  },

  // Sura Öl & Belgisk Jäst
  {
    name: 'Lallemand Philly Sour',
    lab: 'Lallemand',
    type: 'wild',
    att_min: 72,
    att_max: 77,
    temp_min: 20,
    temp_max: 25,
    desc: 'Unik jäststams-art som bildar mjölksyra direkt under första dagarnas jäsning för Sour IPA & Berliner Weisse.',
  },
  {
    name: 'SafAle BE-134 Saison',
    lab: 'Fermentis',
    type: 'belgian',
    att_min: 80,
    att_max: 90,
    temp_min: 18,
    temp_max: 28,
    desc: 'Saisonjäst i torrform med hög förgäsning och pepprig avslutning.',
  },
  {
    name: 'Wyeast 3068 Weizen',
    lab: 'Wyeast',
    type: 'wheat',
    att_min: 73,
    att_max: 77,
    temp_min: 18,
    temp_max: 24,
    desc: 'Klassisk tysk Hefeweizen. Perfekt balans mellan banan och kryddnejlika.',
  },
  {
    name: 'Safbrew WB-06',
    lab: 'Fermentis',
    type: 'wheat',
    att_min: 76,
    att_max: 80,
    temp_min: 18,
    temp_max: 24,
    desc: 'Torr vete-jäst för kryddig tysk Hefeweizen.',
  },
];
